import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const getAccountsOptions = (channel?: string) =>
  queryOptions({
    queryKey: [{ entity: "accounts", params: { channel } }],
    queryFn: async () => await apiClient.getAccounts({ queries: { channel } }),
  });
